"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabCarouselMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const molecules_1 = require("../../molecules");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const hooks_1 = require("../../hooks");
const constants_1 = require("../../constants");
function TabCarouselMobile() {
    const availableTabs = (0, hooks_1.useAvailableTabs)(true);
    const [{ currentTab, previousTab }] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const [tabsHeights, setTabsHeights] = (0, react_1.useState)({});
    const setTabHeight = (type) => ({ height }) => {
        if (!height ||
            (tabsHeights[type] !== undefined && height <= tabsHeights[type])) {
            return;
        }
        /**
         * I think that 160 is a difference between tab and tab content heights.
         * ✨160 is a magic number ✨
         */
        const croppedHeight = Math.min(height + 160, window.innerHeight - 0.75 * window.innerWidth - 160);
        const heights = Object.assign({}, tabsHeights);
        heights[type] = croppedHeight;
        setTabsHeights(heights);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'TabCarouselMobile_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.TabButtons, { "data-e2e": 'TabCarouselMobile_TabButtons' }), (0, jsx_runtime_1.jsx)(TabsContainer, { "data-e2e": 'TabCarouselMobile_TabsContainer', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !!currentTab, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'TabCarouselMobile_CSSTransition', children: (0, jsx_runtime_1.jsx)(TabContainer, { "data-e2e": 'TabCarouselMobile_TabContainer', children: availableTabs.map((type) => {
                            const tabShouldBeOpened = (!!currentTab && currentTab === type) ||
                                (!currentTab && previousTab === type);
                            const TabContent = (0, react_1.lazy)(() => (0, constants_1.getTabComponentByType)(type));
                            return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: tabShouldBeOpened, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'TabCarouselMobile_CSSTransition', children: (0, jsx_runtime_1.jsx)(Tab, { "$selectedTabHeight": tabsHeights[currentTab]
                                        ? `${tabsHeights[currentTab]}px`
                                        : 'auto', "$previousTabHeight": tabsHeights[previousTab]
                                        ? `${tabsHeights[previousTab]}px`
                                        : 'auto', "data-e2e": 'TabCarouselMobile_Tab', children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { "data-e2e": 'TabCarouselMobile_Suspense', children: (0, jsx_runtime_1.jsx)(TabContent, { onResize: setTabHeight(type), "data-e2e": 'TabCarouselMobile_TabContent' }) }) }) }, type));
                        }) }) }) })] }));
}
exports.TabCarouselMobile = TabCarouselMobile;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  width: 100%;

  overflow: hidden;
`;
const TabsContainer = styled_components_1.default.div `
  display: flex;

  margin-top: 16px;

  overflow: hidden;
`;
const TabContainer = styled_components_1.default.div `
  position: relative;

  width: 100%;
  max-height: 100%;

  overflow: hidden;

  transition: height 0.2s ease-in-out;

  &.enter {
    height: 0;
  }

  &.enter-active,
  &.enter-done,
  &.exit {
    height: auto;
  }

  &.exit-active {
    height: 0;
  }
`;
const Tab = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;
  width: 100%;
  height: ${({ $selectedTabHeight }) => $selectedTabHeight};
  max-height: 100%;
  padding: 0 8px 16px 16px;
  overflow: hidden;

  transition: opacity 0.3s ease-in-out, height 0.3s linear;

  &.enter,
  &.enter-active {
    height: ${({ $previousTabHeight }) => $previousTabHeight};

    opacity: 0;
  }

  &.enter-done {
    height: ${({ $selectedTabHeight }) => $selectedTabHeight};

    opacity: 1;
  }

  &.exit,
  &.exit-active {
    position: absolute;
    top: 0;
    left: 0;

    opacity: 0;
  }
`;
